<template>
  <section>
    <AprobarProgramacionJefeInmediato />
    <RechazarProgramacionJefeInmediato />
    <ValidarProgramacionJefeInmediato />
    <ValidarProgramacionJefeInmediatoPorFuncionario />
    <VerDetalleSolicitudes />
    <VerDetalleSolicitudesProgramacion />
    <h3 class="primary--text">
      <v-icon color="primary">people</v-icon>
      Programación de vacaciones
    </h3>
    <v-card elevation="0">
      <v-card-text>
        <strong>DEPENDENCIA: </strong
        >{{ this.$storage.get("user").unidad[0].nombre_unidad }}
        <br />
        <strong>AÑO DE PROGRAMACIÓN: </strong>{{ this.$route.params.gestion }}

        <v-layout>
          <!-- Boton validar -->
          <v-tooltip bottom>
            <v-btn
              color="rgba(156, 80, 162 ,0.3)"
              @click.prevent="validarProgramacionJefeInmediato()"
              slot="activator"
              :disabled="!this.valida_programacion"
              ><v-icon dark>done</v-icon>Validar programación dependencia
            </v-btn>
            <span>Validar programaciones</span>
          </v-tooltip>
          <!-- Boton aprobar -->
          <v-tooltip bottom>
            <v-btn
              color="rgba(103,15,121,0.6)"
              @click.prevent="aprobarProgramacionJefeInmediato()"
              slot="activator"
              :disabled="!this.aprueba_programacion"
              ><v-icon dark>play_arrow</v-icon>Aprobar programación dependencia
            </v-btn>
            <span>Enviar al jefe superior jerarquico</span>
          </v-tooltip>
          <!-- Boton filtro -->
          <v-tooltip bottom>
            <v-btn
              @click.native="
                () => {
                  filterShow = true;
                }
              "
              class="btn-refresh"
              slot="activator"
              ><v-icon>filter_list</v-icon>
            </v-btn>
            <span>Búsqueda/filtros</span>
          </v-tooltip>
          <!-- Boton acutualizar -->
          <v-tooltip bottom>
            <v-btn
              @click.native="cargarProgramacionesGeneral()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
        </v-layout>
        <!-- Filtros-->
        <v-card color="#eeffff" v-if="filterShow">
          <v-card-text id="sin_margen2">
            <v-container class="v_card expandir" grid-list-md>
              <v-layout
                ><h3>Filtros</h3>
                <v-spacer></v-spacer>
                <v-btn
                  id="sinMargen2"
                  icon
                  @click.native="
                    () => {
                      filterShow = false;
                      recargar();
                    }
                  "
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-layout>
              <v-layout wrap>
                <v-flex xs4>
                  <v-text-field
                    append-icon="search"
                    label="Servidor público"
                    single-line
                    hide-details
                    @input="filterServidorPublico"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    append-icon="search"
                    label="Fecha incorporación"
                    single-line
                    hide-details
                    @input="filterFechaIncorporacion"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    append-icon="search"
                    label="Saldo corte"
                    single-line
                    hide-details
                    @input="filterSaldoCorte"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    append-icon="search"
                    label="Dias asignados"
                    single-line
                    hide-details
                    @input="filterDiasAsignados"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    append-icon="search"
                    label="Total a programar"
                    single-line
                    hide-details
                    @input="filterDiasProgramar"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <br />
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="lista_funcionarios_vacaciones"
          no-data-text="Sin datos"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          no-results-text="No se encontro coincidencias"
          :rows-per-page-items="[5, 10, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Filas por pagina"
          hide-actions
        >
          <!-- Cabecera -->
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="letra-cabecera">
                  {{ props.header.text }}
                </span>
              </template>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:items="items">
            <td class="text-xs-center">{{ items.item.servidor_publico }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_incorporacion).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.dias_saldo_a }}</td>
            <td class="text-xs-center">{{ items.item.dias_saldo_b }}</td>
            <td class="text-xs-center">{{ items.item.dias_saldo_c }}</td>
            <td class="text-xs-center">{{ items.item.total_dias_saldo }}</td>
            <td class="text-xs-center">{{ items.item.dias_programar }}</td>
            <td class="text-xs-center">{{ items.item.dias_no_programados }}</td>
            <td class="text-xs-center">
              {{ items.item.ene != 0 ? items.item.ene : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.feb != 0 ? items.item.feb : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.mar != 0 ? items.item.mar : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.abr != 0 ? items.item.abr : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.may != 0 ? items.item.may : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.jun != 0 ? items.item.jun : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.jul != 0 ? items.item.jul : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.ago != 0 ? items.item.ago : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.sep != 0 ? items.item.sep : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.oct != 0 ? items.item.oct : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.nov != 0 ? items.item.nov : "-" }}
            </td>
            <td class="text-xs-center">
              {{ items.item.dic != 0 ? items.item.dic : "-" }}
            </td>
            <td class="text-xs-center">{{ items.item.estado }}</td>
            <td nowrap>
              <v-btn
                color="#0594A5"
                @click.prevent="verDetalleProgramacion(items.item)"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                color="#6DE0BA"
                @click.prevent="verDetalle(items.item)"
                icon
                title="Descripción"
              >
                <v-icon>receipt</v-icon>
              </v-btn>
              <v-btn
                color="#FF5D34"
                v-if="items.item.id_estado_vaca_progra == 51"
                @click="rechazarProgramacionJefeInmediato(items.item)"
                icon
                title="Rechazar"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <!-- Validar -->
              <v-btn
                color="#f1b3f6"
                v-if="items.item.id_estado_vaca_progra == 51"
                @click="
                  validarProgramacionJefeInmediatoPorFuncionario(items.item)
                "
                icon
                title="Validar programación"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <!-- Enviar al jefe sup. -->
              <!-- <v-btn
                color="#72e2b7"
                v-if="items.item.id_estado_vaca_progra == 51"
                @click="aprobarProgramacionJefeInmediatoPorFuncionario(items.item)"
                icon
                title="Enviar programación al jefe superior jerarquico"
              >
                <v-icon>send</v-icon>
              </v-btn> -->
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import VerDetalleSolicitudes from "./dialogs/VerDetalleSolicitudes";
import VerDetalleSolicitudesProgramacion from "./dialogs/VerDetalleSolicitudesProgramacion";
import AprobarProgramacionJefeInmediato from "./dialogs/AprobarProgramacionJefeInmediato";
import ValidarProgramacionJefeInmediato from "./dialogs/ValidarProgramacionJefeInmediato";
import ValidarProgramacionJefeInmediatoPorFuncionario from "./dialogs/ValidarProgramacionJefeInmediatoPorFuncionario";
import RechazarProgramacionJefeInmediato from "./dialogs/RechazarProgramacionJefeInmediato";
import filtros from "./mixins/filtros";
export default {
  mixins: [filtros],
  data() {
    let user = this.$storage.get("user");
    let id_persona = user.id_persona;
    return {
      persona: null,
      loading: false,
      img_url: "",
      funcionario: null,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      persona: null,
      saldo: null,
      valida_programacion: true,
      aprueba_programacion: true,
      // variables datatable
      lista_funcionarios_vacaciones: [],
      gestion: parseInt(this.$route.params.gestion),
      unidad: this.$storage.get("user").unidad[0],
      // Variables filtros
      filterShow: true,
      filters: {
        servidor_publico: "",
        fecha_incorporacion: "",
        saldo_corte: "",
        dias_asignados: "",
        dias_programar: ""
      }
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Servidor público",
          value: "id",
          align: "center",
          class: "celda2"
        },
        {
          text: "Fecha de incorporación",
          value: "fecha_solicitud",
          align: "center",
          class: "celda2"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 3}-${this.gestion -
            2}\n(A)`,
          value: "dias_saldo_a",
          align: "center",
          class: "celda2"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 2}-${this.gestion -
            1}\n(B)`,
          value: "dias_saldo_b",
          align: "center",
          class: "celda2"
        },
        {
          text: `SALDO DE VACACION PERIODO ${this.gestion - 1}-${
            this.gestion
          }\n(C)`,
          value: "dias_saldo_c",
          align: "center",
          class: "celda2"
        },
        {
          text: `TOTAL DIAS\n(A+B+C)`,
          value: "total_dias_saldo",
          align: "center",
          class: "celda2"
        },
        {
          text: `TOTAL DIAS PROGRAMADOS DE ACUERDO A PORCENTAJE`,
          value: "dias_programar",
          align: "center",
          class: "celda2"
        },
        {
          text: `TOTAL DIAS NO PROGRAMADOS`,
          value: "dias_no_programados",
          align: "center",
          class: "celda2"
        },
        { text: "Ene", value: "", align: "center", class: "celda2" },
        { text: "Feb", value: "", align: "center", class: "celda2" },
        { text: "Mar", value: "", align: "center", class: "celda2" },
        { text: "Abr", value: "", align: "center", class: "celda2" },
        { text: "May", value: "", align: "center", class: "celda2" },
        { text: "Jun", value: "", align: "center", class: "celda2" },
        { text: "Jul", value: "", align: "center", class: "celda2" },
        { text: "Ago", value: "", align: "center", class: "celda2" },
        { text: "Sep", value: "", align: "center", class: "celda2" },
        { text: "Oct", value: "", align: "center", class: "celda2" },
        { text: "Nov", value: "", align: "center", class: "celda2" },
        { text: "Dic", value: "", align: "center", class: "celda2" },
        { text: "Estado", value: "estado", align: "center", class: "celda2" },
        {
          text: this.$t("common.actions"),
          sortable: false,
          align: "center",
          class: "celda2"
        }
      ];
    }
  },
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    this.$bus.$on("closeDialogAprobarProgramacionJefeInmediato", async () => {
      await this.cargarProgramacionesGeneral();
      await this.validaProgramacion();
      await this.apruebaProgramacion();
    });
    this.$bus.$on(
      "closeDialogRechazarProgramacionJefeInmediatoPorFuncionario",
      async () => {
        await this.cargarProgramacionesGeneral();
        await this.validaProgramacion();
        await this.apruebaProgramacion();
      }
    );
    this.$bus.$on("closeDialogRechazarProgramacionJefeInmediato", async () => {
      await this.cargarProgramacionesGeneral();
      await this.validaProgramacion();
      await this.apruebaProgramacion();
    });
    this.$bus.$on("closeDialogValidarProgramacionJefeInmediato", async () => {
      await this.cargarProgramacionesGeneral();
      await this.validaProgramacion();
      await this.apruebaProgramacion();
    });
    this.$bus.$on(
      "closeDialogValidarProgramacionJefeInmediatoPorFuncionario",
      async () => {
        // await this.cargarProgramacionesGeneral();
        // await this.validaProgramacion();
        // await this.apruebaProgramacion();
      }
    );
    this.$bus.$on("closeDialogVerDetalleSol", async () => {
      await this.cargarProgramacionesGeneral();
    });
    this.$bus.$on("closeDialogVerDetallesProg", async () => {
      await this.cargarProgramacionesGeneral();
    });
    this.getAño();
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarProgramacionesGeneral();
    await this.validaProgramacion();
    await this.apruebaProgramacion();
  },

  methods: {
    getAño() {
      let año = new Date().getFullYear() + "";

      return año;
    },
    async apruebaProgramacion() {
      try {
        let contador_aprobados_jefe = 0;
        let contador_validados_jefe = 0;
        let id_unidad = parseInt(this.$storage.get("user").unidad[0].id);

        let res = await this.$service.graphql({
          query: `
          query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${id_unidad},${this.$route.params.gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vaca_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
          `
        });
        res = res.runQuery.respuesta;
        let listado_funcionarios = res;
        listado_funcionarios.forEach(element => {
          if (element.id_estado_vaca_progra == 73) {
            contador_validados_jefe++;
          }
          if (element.id_estado_vaca_progra == 66) {
            contador_aprobados_jefe++;
          }
          // if (element.id_estado_vaca_progra == 22 || element.id_estado_vaca_progra == 47 || element.id_estado_vaca_progra == 51) {
          //   this.aprueba_programacion = false;
          //   return;
          // }
        });
        // if (contador_aprobados_jefe==listado_funcionarios.length ) {
        //    this.aprueba_programacion = false;
        // }
        if (contador_validados_jefe == 0) {
          this.aprueba_programacion = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async validaProgramacion() {
      try {
        let contador_pendientes_aprobacion = 0;

        let id_unidad = parseInt(this.$storage.get("user").unidad[0].id);
        let res = await this.$service.graphql({
          query: `
          query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${id_unidad},${this.$route.params.gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vaca_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
          `
        });
        res = res.runQuery.respuesta;
        let listado_funcionarios = res;
        listado_funcionarios.forEach(element => {
          //  if (element.id_estado_vaca_progra ==73) {//validados
          //      contador_validados++
          //   }
          if (element.id_estado_vaca_progra == 51) {
            //pendientes de aprobacion
            contador_pendientes_aprobacion++;
          }
        });
        if (contador_pendientes_aprobacion == 0) {
          this.valida_programacion = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    aprobarProgramacionJefeInmediato() {
      this.$bus.$emit("openDialogAprobarProgramacionJefeInmediato");
    },
    rechazarProgramacionJefeInmediato(item) {
      this.$bus.$emit("openDialogRechazarProgramacionJefeInmediato", item);
    },
    validarProgramacionJefeInmediatoPorFuncionario(item) {
      this.$bus.$emit(
        "openDialogValidarProgramacionJefeInmediatoPorFuncionario",
        item
      );
    },

    validarProgramacionJefeInmediato(item) {
      this.$bus.$emit("openDialogValidarProgramacionJefeInmediato", item);
    },

    // Metodo para cargar el listado
    async cargarProgramacionesGeneral() {
      try {
        let res = await this.$service.graphql({
          query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${this.unidad.id},${this.gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vaca_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
        });
        res = res.runQuery.respuesta;
        this.lista_funcionarios_vacaciones = res;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para abrir dialod detalle
    verDetalle(item) {
      this.$bus.$emit("openDialogVerDetalleSolicitudes", item);
    },
    verDetalleProgramacion(item) {
      this.$bus.$emit("openDialogVerDetalleSolicitudesProgramacion", item);
    }
  },
  components: {
    VerDetalleSolicitudes,
    VerDetalleSolicitudesProgramacion,
    AprobarProgramacionJefeInmediato,
    RechazarProgramacionJefeInmediato,
    ValidarProgramacionJefeInmediato,
    ValidarProgramacionJefeInmediatoPorFuncionario
  }
};
</script>
<style>
.celda2 {
  white-space: pre;
  word-wrap: break-word;
  background: rgba(0, 165, 151, 0.438);
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
  border: solid 0.0001em rgba(65, 144, 150, 0.589);
}
.v_card {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
}
#sin_margen2 {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 1em 0em;
}
h3 {
  color: rgb(1, 3, 85);
}
.expandir {
  min-width: 100%;
}
.letra-cabecera {
  color: rgb(0, 0, 0);
  white-space: pre-line;
  word-wrap: break-word;
  font-weight: bolder;
  font-size: 1.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/VacacionAprobarJefe1.vue